import React, { useState } from 'react'
import PropTypes from 'prop-types'

import { VBox, HBox, Box } from 'app/views/core/Box'
import { getEngineDisplayName } from 'app/views/utils/engine'

import TestSubmissionHeading from './TestSubmissionHeading'
import TestSubmissionExplanation from './TestSubmissionExplanation'
import TestStageList from './TestStageList'
import TestSubmissionCodeModal from './TestSubmissionCodeModal'

function TestSubmissionDetails(props) {
  const { submissionId, submittedAt, engine, code, stages } = props
  const { result, failedStage } = props
  const [wantsCode, setWantsCode] = useState(false)
  return (
    <VBox style={{ padding: 30 }}>
      <HBox>
        <TestSubmissionHeading
          result={result}
          submittedAt={submittedAt}
        />
        {code.length > 0 && (
          <Box>
            <button
              className={`uk-button uk-button-small${result !== 'pending' ? (` uk-button-${result === 'passed' ? 'primary' : 'danger'}`) : ''}`}
              style={{ marginTop: 6 }}
              onClick={() => setWantsCode(true)}
            >
              View {getEngineDisplayName(engine)} Code
            </button>
          </Box>
        )}
      </HBox>
      <TestSubmissionExplanation
        result={result}
      />
      <TestStageList
        submissionResult={result}
        stages={stages}
        failedStageName={failedStage ? failedStage.name : null}
        failedStageHelpUrl={failedStage ? failedStage.helpUrl : null}
      />
      {wantsCode && (
        <TestSubmissionCodeModal
          engine={engine}
          code={code}
          onClose={() => setWantsCode(false)}
        />
      )}
    </VBox>
  )
}
TestSubmissionDetails.propTypes = {
  submissionId: PropTypes.number.isRequired,
  submittedAt: PropTypes.string.isRequired,
  engine: PropTypes.string.isRequired,
  code: PropTypes.string.isRequired,
  stages: PropTypes.arrayOf(PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    description: PropTypes.string,
  })).isRequired,

  result: PropTypes.oneOf(['passed', 'failed', 'pending']).isRequired,
  failedStage: PropTypes.shape({
    name: PropTypes.string.isRequired,
    title: PropTypes.string,
    description: PropTypes.string,
    helpUrl: PropTypes.string,
    errorMessage: PropTypes.string,
    errorStackTrace: PropTypes.string,
  }),
}

export default TestSubmissionDetails
